/* eslint-disable no-unused-vars  */

export enum NavigationEvents {
  NAVIGATION_FILL = 'NAVIGATION::FILL',
  NAVIGATION_TRANSPARENT = 'NAVIGATION::TRANSPARENT',
}